import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometouch',
  templateUrl: './hometouch.component.html',
  styleUrls: ['./hometouch.component.scss']
})
export class HometouchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
